import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export type CreateOrganizationUserPayloadType = {
  role: 'org_admin' | 'master_admin';
  email: string;
  mobile_phone: string;
  first_name: string;
  middle_name?: string;
  last_name: string;
};

export const createOrganizationUserApi = async (
  organizationId: string,
  data: CreateOrganizationUserPayloadType,
  params?: ApiParams,
  options?: RequestOptions
): Promise<ApiResponseType<CreateOrganizationUserPayloadType>> => {
  const uri = `/opco/organizations/${organizationId}/users/`;

  return authApiService.POST(uri, data, params, options);
};
